import {Component} from "react";
import "./ContactsStyles.css";
import Markets from "../Markets";
import FancyNavigation from "../ScrollSpyPagination/PaginationNavigation";

class Contacts extends Component {
    render() {
        return (
            <div className={"contacts-info"}>
                <FancyNavigation/>
                {/*<div className={"contacts-info-container"}>*/}
                {/*    <div className={"contacts-info-apps"}>*/}
                {/*        <h5 className={"contacts-info-apps_title"}>Скачивайте приложение на свой телефон!</h5>*/}
                {/*        <Markets/>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        );
    }
}

export default Contacts;